import React from 'react';
import { Box, } from '@waglabs/box-next';
export const Grid = (props) => (React.createElement(Box, Object.assign({}, props, { display: "grid" })));
